export default "data:video/mp2t;base64,aW1wb3J0IFRFbXB0eSBmcm9tICIuL1RFbXB0eS52dWUiOwoKZXhwb3J0IGRlZmF1bHQgVEVtcHR5Owo="